import { useEffect, useState } from 'react';
import type { VersandListe } from '@arbeitsrapporte/shared';
import { api } from '../api';
import { Fehler } from '../bausteine/Meldung';

/** Die Outbox – was auf dem Weg zum ERP ist oder dort nicht ankam. */
export function Versand() {
  const [liste, setListe] = useState<VersandListe | null>(null);
  const [fehler, setFehler] = useState<unknown>(null);

  const lade = () => api.versand().then(setListe).catch(setFehler);
  const eintraege = liste?.daten ?? null;

  useEffect(() => {
    void lade();
  }, []);

  const erneut = async (id: string) => {
    try {
      await api.versandErneut(id);
      await lade();
    } catch (f) {
      setFehler(f);
    }
  };

  return (
    <>
      <h1 className="mb-1 text-2xl font-semibold">Versand an das ERP</h1>
      <p className="mb-4 text-slate-600">
        Freigegebene Rapporte, die noch nicht gebucht sind – oder deren Buchung aufgegeben wurde.
      </p>

      <Fehler fehler={fehler} />

      {/*
        Ein Satz statt zwanzig roter Kästen: Solange der Hub die Route nicht
        hat oder das Schreibtoken fehlt, warten alle Einträge auf dasselbe –
        das ist eine Auskunft über die Einrichtung, kein Fehler je Rapport.
      */}
      {liste?.hinweis && (
        <p className="mb-4 rounded border border-sky-300 bg-sky-50 px-4 py-2 text-sm text-sky-900">
          {liste.hinweis} Die Einträge bleiben stehen und gehen von selbst, sobald es so weit ist.
        </p>
      )}

      {eintraege?.length === 0 && (
        <p className="text-slate-600">Nichts offen. Alles ist gebucht.</p>
      )}

      <ul className="space-y-2">
        {eintraege?.map((e) => (
          <li key={e.id}>
            <div className="karte">
              <div className="flex items-center gap-3">
                <a
                  href={`/rapport/${e.rapportId}`}
                  className="font-semibold text-slate-900 underline underline-offset-4 hover:text-slate-600"
                >
                  {e.rapportNummer}
                </a>
                <span
                  className={`ml-auto shrink-0 rounded border px-2 py-0.5 text-xs font-medium whitespace-nowrap ${
                    e.status === 'fehlgeschlagen'
                      ? 'border-rose-300 bg-rose-50 text-rose-900'
                      : 'border-slate-300 bg-slate-100 text-slate-700'
                  }`}
                >
                  {e.status}
                </span>
              </div>

              <div className="mt-1 text-sm text-slate-500">
                {e.versuche} Versuch(e)
                {e.naechsterVersuchAm &&
                  e.status === 'offen' &&
                  ` · nächster ${new Date(e.naechsterVersuchAm).toLocaleString('de-CH')}`}
              </div>

              {e.letzterFehler && !e.wartetAufEinrichtung && (
                <p className="mt-2 rounded border border-rose-300 bg-rose-50 px-3 py-2 text-sm text-rose-900">
                  {e.letzterFehler}
                </p>
              )}

              {e.status === 'fehlgeschlagen' && (
                <button type="button" onClick={() => erneut(e.id)} className="knopf mt-3">
                  Erneut versuchen
                </button>
              )}
            </div>
          </li>
        ))}
      </ul>
    </>
  );
}
